// Imports
import React from 'react';
import PageTitle from '../shared-components/page-title';
import LeadingText from '../shared-components/leading-text';


// Function component
const ContentAreaError: React.FC = () => {
	// Return JSX
	return (
		<React.Fragment>
			<PageTitle appendCommunityName={false} documentTitle='Unexpected error'>
				Something went wrong
			</PageTitle>
			
			<LeadingText>An unexpected issue occurred, and our engineering team has been notified.</LeadingText>
		</React.Fragment>
	);
};

export default ContentAreaError;
